import React, {
  useReducer,
  useContext,
  useRef,
  useEffect,
  useMemo,
} from "react";
import moment from "moment";
import { saveTempOrder, GetTempOrderDetail } from "../../Api/GetOrder";
import { withRouter } from "react-router-dom";
import { CusButton } from "../../Components/From/Button";
import Tool_CusFilter from "../../Components/Tools/Tool_CusFilter";
import { FormattedMessage } from "react-intl";
import { Global } from "../../App";
import { browserName } from "react-device-detect";
import { AsyncModel, AsyncModelClose } from "../AsyncModel/AsyncModel";

import _ from "lodash";
import cls from "classnames";
import Tooltip from "rc-tooltip";
import Tool_circulatingTab from "../../Components/Tools/Tool_circulatingTab";
import PerfectScrollbar from "react-perfect-scrollbar";
import "../../Pages/pages.scss";
// switch lang
import { langStringToCode } from "../../Share/Tools/switchLang";
// api
import { getBranchProduct } from "../../Api/GetProduct";
import { getTagList } from "../../Api/GetProduct";

import defaultImg from "../../Resource/image/icons/img_no_image.png";
import ScrollTabs from "../../Components/Common/ScrollTabs";
import { updateOrderDetail } from "../../Share/Tools/updateOrderDetail";
import calcListTotal from "../../Share/Tools/calcTotal";
import { splitData } from "../../Share/Tools/splitData";
import ReactLoading from "react-loading";
import { TimeOutSet, TimeOutRemove } from "../../Share/Tools/Share";

let pageTimer = {};
let bUpdate = false;
const reducer = (state, { type, payload }) => {
  let newState = { ...state };
  switch (type) {
    case "UPDATE_STATE":
      payload.forEach((i) => {
        newState[i.key] = i.val;
      });
      return newState;
    default:
      return newState;
  }
};

/**
 *
 * @param {object} props
 *
 * 本次步驟會影響的global state
 *
 * currentStep (3 => 3.1 || 4)
 * currentQrStep (1 => 1.1 || 2)
 * mealDetail
 * mealOrderDetail
 */

function OrderStep_3(props) {
  const { globalState, dispatchGlobal } = useContext(Global);
  const [state, dispatch] = useReducer(reducer, {
    currentCategory: null,
    searchInput: "",
    categoryList: [], // tab
    filterCategoryList: [],
    mealList: [], // meals,
    dineIn: [],
    takeout: [],
    tagList: {}, //tags
    tagSelected: [],
    veganSelected: [],
    tagPopupToggle: false,
  });
  const _menuListRef = useRef([]);

  // 計算餐點數量&總金額(餐點單價*數量 + 特口價格*數量)
  const handleTotalPrice = useMemo(() => {
    const { mealOrderDetail } = globalState.customer;
    const totalQuantity = mealOrderDetail.length;
    // 內用總單價
    const dineInTotal = mealOrderDetail.reduce((currProduct, itemProduct) => {
      const total = itemProduct.specification.reduce((currSpec, itemSpec) => {
        return (
          currSpec +
          itemSpec.combination
            .filter((combi) => !combi.takeout)
            .reduce((currCombi, itemCombi) => {
              return currCombi + itemCombi.quantity * itemSpec.price;
            }, 0)
        );
      }, 0);
      return currProduct + total;
    }, 0);
    // 內用特口總價
    const dineInSpecPrice = mealOrderDetail.reduce(
      (currProduct, itemProduct) => {
        let spec = itemProduct.specification.reduce((currSpec, itemSpec) => {
          return (
            currSpec +
            itemSpec.combination
              .filter((combi) => !combi.takeout)
              .reduce((currCombi, itemCombi) => {
                const specTotalPrice = itemCombi.taste.reduce(
                  (currTaste, itemTaste) => {
                    let index = itemProduct.stayInTaste.findIndex(
                      (f) => f.id === itemTaste
                    );
                    // 各個組合的數量
                    let combiQuantity = itemCombi.quantity;
                    // 對應特口需求的價格
                    let tastePrice = itemProduct.stayInTaste[index].price;
                    return currTaste + tastePrice * combiQuantity;
                  },
                  0
                );
                return currCombi + specTotalPrice;
              }, 0)
          );
        }, 0);
        return currProduct + spec;
      },
      0
    );
    // 外帶總單價
    const takeoutTotal = mealOrderDetail.reduce((currProduct, itemProduct) => {
      const total = itemProduct.specification.reduce((currSpec, itemSpec) => {
        return (
          currSpec +
          itemSpec.combination
            .filter((combi) => combi.takeout)
            .reduce((currCombi, itemCombi) => {
              return currCombi + itemCombi.quantity * itemSpec.price;
            }, 0)
        );
      }, 0);
      return currProduct + total;
    }, 0);
    // 外帶特口總價
    const takeoutSpecPrice = mealOrderDetail.reduce(
      (currProduct, itemProduct) => {
        let spec = itemProduct.specification.reduce((currSpec, itemSpec) => {
          return (
            currSpec +
            itemSpec.combination
              .filter((combi) => combi.takeout)
              .reduce((currCombi, itemCombi) => {
                const specTotalPrice = itemCombi.taste.reduce(
                  (currTaste, itemTaste) => {
                    let index = itemProduct.takeoutTaste.findIndex(
                      (f) => f.id === itemTaste
                    );
                    // 各個組合的數量
                    let combiQuantity = itemCombi.quantity;
                    // 對應特口需求的價格
                    let tastePrice = itemProduct.takeoutTaste[index].price;
                    return currTaste + tastePrice * combiQuantity;
                  },
                  0
                );
                return currCombi + specTotalPrice;
              }, 0)
          );
        }, 0);
        return currProduct + spec;
      },
      0
    );
    return {
      totalMealQuantity: totalQuantity,
      dineInTotalPrice: dineInTotal,
      dineInSpecPrice: dineInSpecPrice,
      takeoutInTotalPrice: takeoutTotal,
      takeoutInSpecPrice: takeoutSpecPrice,
    };
  }, [globalState.customer.mealOrderDetail]);

  // 四捨五入至小數點第n位
  const formatNumber = (value, pos) => {
    const float = Math.pow(10, pos);
    return (Math.round(value * float) / float).toFixed(pos);
  };

  // 處理特口、外帶狀態相同的組合要合併成同一欄
  function merge(data, specificationData) {
    let deep;
    if (!data) {
      deep = _.cloneDeep(specificationData);
    } else {
      deep = _.cloneDeep(data);
    }
    let isEquals = (a, b) => {
      return (
        a.takeout === b.takeout &&
        a.taste.sort().toString() === b.taste.sort().toString()
      );
    };
    const { specification } = deep;
    specification.map((spec) => {
      const combin = spec.combination.reduce((current, item) => {
        const findIndex = current.findIndex((item1) => isEquals(item, item1));
        if (findIndex === -1) {
          return [...current, item];
        } else {
          const nextCurrent = current.slice(0);
          const isLimit =
            item.quantity + nextCurrent[findIndex].quantity >= 99
              ? 99
              : item.quantity + nextCurrent[findIndex].quantity;
          if (item.quantity + nextCurrent[findIndex].quantity > 99)
            AsyncModel({
              title: globalState.langFile["popup.itemLimit"],
              cancelBtnText: globalState.langFile["popup.buttonCancel"],
              confirmBtnText: globalState.langFile["popup.buttonConfirm"],
            });

          nextCurrent[findIndex] = {
            ...nextCurrent[findIndex],
            quantity: isLimit,
          };
          return nextCurrent;
        }
      }, []);
      spec.combination = combin;
    });
    return deep;
  }

  async function apiBranchProduct(langId, storeId) {
    const backToStep2 = () => {
      dispatchGlobal({
        type: "UPDATE",
        payload: [
          {
            key: "customer",
            val: {
              ...globalState.customer,
              currentStep: "2",
              mealDetail: "",
              mealOrderDetail: [],
              orderDetail: {
                totalMealQuantity: 0,
                dineInTotalPrice: 0,
                dineInSpecPrice: 0,
                takeoutInTotalPrice: 0,
                takeoutInSpecPrice: 0,
              },
            },
          },
        ],
      });
    };
    try {
      const waittingAlert = AsyncModel({
        content: (
          <div className="w-100 d-flex justify-content-center">
            <ReactLoading
              type="spokes"
              color="#ccc"
              height="100px"
              width="100px"
            />
          </div>
        ),
        showConfirmBtn: false,
      });
      const res = await getBranchProduct(langId, storeId);
      AsyncModelClose();
      const { errCode, productList } = res.data;
      if (errCode === 200) {
        // 分類tabs
        let _categoryList = [];
        // let _categoryList = productList.map(e => ({
        //   title: e.name,
        //   type: e.id
        // }));
        // let _categoryList = productList.filter(e =>
        //   // 只顯示user可用
        //   (e.type_order_mode === 1 || e.type_order_mode === 2)
        // ).map(e => ({
        //   title: e.name,
        //   type: e.id
        // }));

        // 餐點總攬
        let _mealList = productList.map((e) => {
          let type = e.id;
          let typeName = e.name;
          // 分類同時push進去
          _categoryList.push({
            title: typeName,
            type,
          });
          let newArr = e.product.map((_product) => ({
            type: type,
            typeName: typeName,
            title: _product.name,
            description: _product.description,
            ..._product,
          }));
          // let newArr = e.product.filter(_product =>
          //   // 只顯示user可用
          //   (_product.order_mode === 1 || _product.order_mode === 2)
          // ).map(_product => ({
          //   type: type,
          //   typeName: typeName,
          //   title: _product.name,
          //   description: _product.description,
          //   ..._product
          // }));
          return newArr;
        });

        _mealList = _.flatten(_mealList);

        return { _categoryList, _mealList };
      } else {
        const Alert = await AsyncModel({
          title: globalState.langFile[`errorMsg.errorCode_${errCode}`],
          confirmBtnText: globalState.langFile["popup.buttonConfirm"],
        });

        if (Alert) return backToStep2();
      }
    } catch (err) {
      console.error("Product error.");
      const Alert = await AsyncModel({
        title: globalState.langFile[`errorMsg.errorCode_${407}`],
        confirmBtnText: globalState.langFile["popup.buttonConfirm"],
      });

      if (Alert) return backToStep2();
    }
  }

  async function apiGetTagList(langId) {
    try {
      const res = await getTagList(langId);
      const { errCode, tagList } = res.data;

      if (errCode == 200) {
        return tagList;
      } else {
        console.error("GetTagList error.", errCode);
      }
    } catch (err) {
      console.error("GetTagList error.");
    }
  }

  // 加點API
  async function apiSaveTempOrder(saveData) {
    let res;

    try {
      res = await saveTempOrder(saveData);
    } catch (err) {
      dispatchGlobal({
        type: "UPDATE",
        payload: [{ key: "errMsg", val: 405 }],
      });

      props.history.push("/error");
    }

    let { errCode, order } = res.data;

    if (res && errCode === 200) {
      // const deepCopy = await GetTempOrder(order.tempOrderGroupID);
      dispatchGlobal({
        type: "UPDATE",
        payload: [
          {
            key: "customer",
            val: {
              ...globalState.customer,
              orderInfo: {
                ...globalState.customer.orderInfo,
                tempOrderCode: order.tempOrderCode,
                tempOrderGroupID: order.tempOrderGroupID,
                tempOrderID: order.tempOrderID,
              },
              mealDetail: "",
              //mealOrderDetail: deepCopy,
            },
          },
        ],
      });
    } else {
      dispatchGlobal({
        type: "UPDATE",
        payload: [{ key: "errMsg", val: errCode }],
      });

      props.history.push("/error");
    }
  }

  async function GetTempOrder(tempOrderGroupID) {
    const res = await apiGetTempOrderDetail(
      tempOrderGroupID,
      langStringToCode(globalState.langType),
      globalState.customer.orderInfo.selectedBranch.branchCode,
      moment().format("YYYY/MM/DD"),
      globalState.customer.orderInfo.tableNo
    );

    if (res.errCode === 414) {
      TimeOutRemove();

      const Alert = await AsyncModel({
        title: globalState.langFile[`pages.takeOrder.AddOrderMsg`],
        confirmBtnText:
          globalState.langFile["pages.takeOrder.step5.buttonDetail"],
      });
      //AsyncModelClose();

      if (Alert) {
        props.history.push(
          `/showOrderDetail?orderCode=${
            globalState.customer.orderInfo.mainOrderCode
          }&storeID=${String(
            globalState.customer.orderInfo.selectedBranch.branchCode
          )}&createAt=${moment().format("YYYY/MM/DD")}`
        );
      }
    } else {
      let { dineIn, takeout } = res.productList;
      let deepCopy = [];

      dineIn.map((e) => {
        let productIndex = deepCopy.findIndex((f) => f.id === e.id);

        if (productIndex > -1) {
          const Data = e.specification[0];
          deepCopy[productIndex].specification.push(Data);
        } else {
          deepCopy.push(e);
        }
      });

      takeout.map((e) => {
        let productIndex = deepCopy.findIndex((f) => f.id === e.id);

        if (productIndex > -1) {
          console.log(e.id, e.specification);
          e.specification.map((x) => {
            let deepData = deepCopy[productIndex].specification.filter((e) => {
              return e.id === x.id;
            });
            if (deepData.length > 0) {
              //console.log("deepData", deepData[0].combination)
              // console.log("Data.combination", Data.combination)
              x.combination.map((y) => {
                deepData[0].combination.push(y);
              });
            } else {
              deepCopy[productIndex].specification.push(x);
            }
          });
          //const Data = e.specification[0];

          deepCopy[productIndex].takeoutTaste = e.takeoutTaste;
        } else {
          deepCopy.push(e);
        }
      });
      TimeOutSet(OrderTemp);

      return deepCopy;
    }
  }
  // 取得加點明細
  async function apiGetTempOrderDetail(
    tempOrderGroupID,
    languageID,
    storeID,
    createAt,
    tableNo
  ) {
    let res;

    try {
      res = await GetTempOrderDetail(
        tempOrderGroupID,
        languageID,
        storeID,
        createAt,
        tableNo
      );
    } catch (err) {
      dispatchGlobal({
        type: "UPDATE",
        payload: [{ key: "errMsg", val: 405 }],
      });
      props.history.push("/error");
    }

    let { errCode } = res.data;

    if (res && (errCode === 200 || errCode === 414)) {
      return res.data;
    } else {
      dispatchGlobal({
        type: "UPDATE",
        payload: [{ key: "errMsg", val: errCode }],
      });
      props.history.push("/error");
    }
  }

  // get api 當lang改變時重call api
  useEffect(() => {
    const langCode = langStringToCode(globalState.langType);
    const storeCode = globalState.customer.orderInfo.selectedBranch.branchCode;
    async function handler() {
      const getProduct = await apiBranchProduct(langCode, storeCode);
      const tagList = await apiGetTagList(langCode);

      if (getProduct && tagList) {
        // 加點步驟1 先建立暫存單
        if (
          globalState.ordermode === "addorder" &&
          !globalState.customer.orderInfo.tempOrderID
        ) {
          const AddTempOrder = async () => {
            console.log(globalState.customer.orderInfo.tempOrderGroupID);
            return await apiSaveTempOrder({
              isNew: true,
              queueNumber: globalState.customer.orderInfo.queueNumber,
              queueCode: globalState.customer.orderInfo.queueCode,
              countryID: globalState.customer.orderInfo.country,
              storeID: globalState.customer.orderInfo.selectedBranch.branchCode,
              adultsCount: globalState.customer.orderInfo.numberOfAdult,
              childCount: globalState.customer.orderInfo.numberOfChild,
              userEmail: null,
              totalPrice: 0,
              waiterID: null,
              languageID: langStringToCode(globalState.langType),
              QRCodeID: null,
              mainOrderCode: globalState.customer.orderInfo.mainOrderCode, //加點模式要傳
              posCode: globalState.customer.orderInfo.posCode, //加點模式要傳
              tableNo: globalState.customer.orderInfo.tableNo, //加點模式要傳
              tempOrderID: globalState.customer.orderInfo.tempOrderID,
              tempOrderGroupID: globalState.customer.orderInfo.tempOrderGroupID,
              dineIn: [],
              takeout: [],
            });
          };
          AddTempOrder();
        }
        dispatchGlobal({
          type: "UPDATE",
          payload: [
            {
              key: "customer",
              val: {
                ...globalState.customer,
                veganTags: tagList.vegetarian,
              },
            },
          ],
        });
        dispatch({
          type: "UPDATE_STATE",
          payload: [
            { key: "categoryList", val: getProduct._categoryList },
            {
              key: "mealList",
              val: getProduct._mealList.map((meal) => {
                meal.mealTag = meal.allergen.concat(meal.recommend);
                return meal;
              }),
            },
            { key: "tagList", val: tagList },
            {
              key: "currentCategory",
              val: state.currentCategory || getProduct._categoryList[0],
            },
          ],
        });
      }

      if (
        globalState.ordermode === "addorder" &&
        globalState.customer.orderInfo.tempOrderGroupID
      ) {
        await OrderTemp();
      }
    }

    handler();
  }, [globalState.langType]);

  useEffect(() => {
    async function handler() {
      // 取得用同一號碼其他人的點單
      if (
        globalState.ordermode === "addorder" &&
        globalState.customer.orderInfo.tempOrderGroupID
      ) {
        TimeOutSet(OrderTemp);
      }
    }
    handler();
  }, [globalState.customer.orderInfo.tempOrderGroupID]);

  const OrderTemp = async () => {
    const deepCopy = await GetTempOrder(
      globalState.customer.orderInfo.tempOrderGroupID
    );
    const { mealOrderDetail } = globalState.customer;
    await dispatchGlobal({
      type: "UPDATE",
      payload: [
        {
          key: "customer",
          val: {
            ...globalState.customer,
            mealDetail: "",
            mealOrderDetail: deepCopy,
            orderDetail: {
              totalMealQuantity: mealOrderDetail.length,
              ...handleTotalPrice,
            },
          },
        },
      ],
    });
  };

  // scroll定位在上次選取的項目
  useEffect(() => {
    window.document.body.scrollTop =
      globalState.customer.lastSelectedItemScrolltop || 0;
  }, [state.mealList]);

  const $tabs = useMemo(() => {
    if (state.categoryList !== undefined) {
      let filterArray = [];
      // 有輸入關鍵字
      if (state.searchInput || state.tagSelected || state.veganSelected) {
        let t = state.mealList
          // 關鍵字篩選
          .filter((f) => {
            const target = state.searchInput;

            return (
              f.searchNum.toString().indexOf(target) > -1 ||
              f.name.toLowerCase().indexOf(target.toLowerCase()) > -1
            );
          })
          // 標籤篩選
          .filter((f) => {
            // 沒有全選標籤時
            if (
              globalState.customer.filterTag &&
              globalState.customer.filterTag.length
            ) {
              // 有篩選條件
              if (globalState.customer.filterTag.length) {
                return globalState.customer.filterTag.every((i) =>
                  f.allergenMenu.map((m) => m.id).includes(i)
                );
              } else {
                return f.allergenMenu.length === 0;
              }
            } else {
              return true;
            }
          })
          .filter((f) => {
            if (
              globalState.customer.filterVegan &&
              globalState.customer.filterVegan.length &&
              globalState.customer.filterVegan.length !==
                state.tagList.vegetarian.length
            ) {
              if (globalState.customer.filterVegan.length) {
                return globalState.customer.filterVegan.some((i) =>
                  f.vegetarian.map((m) => m.id).includes(i)
                );
              } else {
                return f.vegetarian.length === 0;
              }
            } else {
              return true;
            }
          });

        // 找出有該關鍵字的分類type
        filterArray = [...new Set(t.map((item) => item.type))];

        // 轉換回文字
        const filterTabs = state.categoryList.filter(({ type: id1 }) =>
          filterArray.some((id2) => id2 === id1)
        );

        // 有結果
        if (filterTabs.length) {
          let result = filterTabs.map((item) => ({
            title: item.title,
            value: item.type,
            count:
              filterTabs.length === state.categoryList.length
                ? 0
                : t.filter((cnt) => {
                    return cnt.type === item.type;
                  }).length,
          }));

          dispatch({
            type: "UPDATE_STATE",
            payload: [{ key: "filterCategoryList", val: result }],
          });

          return result;
        } else {
          // 查無結果，顯示全分類
          return state.categoryList.map((item) => ({
            title: item.title,
            value: item.type,
            count: 0,
          }));
        }
      } else {
        if (state.filterCategoryList !== undefined) {
          return state.filterCategoryList.map((item) => ({
            title: item.title,
            value: item.type,
            count:
              state.filterCategoryList.length == state.categoryList.length
                ? 0
                : item.count,
          }));
        }

        return state.categoryList.map((item) => ({
          title: item.title,
          value: item.type,
          count: 0,
        }));
      }
    }
    return [];
  }, [
    state.categoryList,
    state.searchInput,
    state.tagSelected,
    state.veganSelected,
  ]);

  const $allTabs = useMemo(() => {
    if (state.categoryList !== undefined) {
      return state.categoryList.map((item) => ({
        title: item.title,
        value: item.type,
        count: 0,
      }));
    }
    return [];
  }, [state.categoryList]);

  const $tabItems = useMemo(() => {
    if (state.mealList !== undefined) {
      if (
        state.searchInput ||
        (state.tagSelected && state.tagSelected.length > 0) ||
        (state.veganSelected && state.veganSelected.length > 0)
      ) {
        // 輸入關鍵字移動到上方
        const { y } = document
          .getElementsByClassName("ScrollTabs")[0]
          .getBoundingClientRect();
        document.body.scrollTo({
          top: document.body.scrollTop + y,
          behavior: "smooth",
        });

        return (
          state.mealList
            // 標籤篩選
            .filter((f) => {
              // 沒有全選標籤時
              if (
                globalState.customer.filterTag &&
                globalState.customer.filterTag.length
              ) {
                // 有篩選條件
                if (globalState.customer.filterTag.length) {
                  return globalState.customer.filterTag.every((i) =>
                    f.allergenMenu.map((m) => m.id).includes(i)
                  );
                } else {
                  return f.allergenMenu.length === 0;
                }
              } else {
                return true;
              }
            })
            .filter((f) => {
              if (
                globalState.customer.filterVegan &&
                globalState.customer.filterVegan.length &&
                globalState.customer.filterVegan.length !==
                  state.tagList.vegetarian.length
              ) {
                if (globalState.customer.filterVegan.length) {
                  return globalState.customer.filterVegan.some((i) =>
                    f.vegetarian.map((m) => m.id).includes(i)
                  );
                } else {
                  return f.vegetarian.length === 0;
                }
              } else {
                return true;
              }
            })
            // 關鍵字篩選
            .filter((f) => {
              const target = state.searchInput;
              return (
                f.searchNum.toString().indexOf(target) > -1 ||
                f.name.toLowerCase().indexOf(target.toLowerCase()) > -1
              );
            })
            .map((item) => ({
              $tab: item.type,
              ...item,
            }))
        );
      } else {
        return (
          state.mealList
            // 標籤篩選
            .filter((f) => {
              // 沒有全選標籤時
              if (
                globalState.customer.filterTag &&
                globalState.customer.filterTag.length
              ) {
                // 有篩選條件
                if (globalState.customer.filterTag.length) {
                  return globalState.customer.filterTag.every((i) =>
                    f.allergenMenu.map((m) => m.id).includes(i)
                  );
                } else {
                  return f.allergenMenu.length === 0;
                }
              } else {
                return true;
              }
            })
            .filter((f) => {
              if (
                globalState.customer.filterVegan &&
                globalState.customer.filterVegan.length &&
                globalState.customer.filterVegan.length !==
                  state.tagList.vegetarian.length
              ) {
                if (globalState.customer.filterVegan.length) {
                  return globalState.customer.filterVegan.some((i) =>
                    f.vegetarian.map((m) => m.id).includes(i)
                  );
                } else {
                  return f.vegetarian.length === 0;
                }
              } else {
                return true;
              }
            })
            .map((item) => ({
              $tab: item.type,
              ...item,
            }))
        );
      }
    }
    return [];
  }, [
    state.mealList,
    state.searchInput,
    state.tagSelected,
    state.veganSelected,
  ]);

  return (
    <>
      <FormattedMessage
        id="pages.takeOrder.step3.searchMenuInputPlaceholder"
        children={(msg) => {
          return (
            <>
              {globalState.ordermode === "addorder" ? (
                <div className="Pages__section align-items-center pb-sm-4">
                  <div className="Pages__title">
                    <div className="pr-2 pl-2 pr-sm-3 pl-sm-3 Pages__action">
                      <p className="txtColorBrown font-bold mt-1 mb-1 mt-sm-2 mb-sm-2 text-3xl">
                        {globalState.customer.orderInfo.tableNo}
                        {globalState.langFile["header.menuItems.tableorder"]}
                      </p>
                      <span className="pr-2 pl-2 pr-sm-3 pl-sm-3 txtColorBrown">
                        {globalState.langFile["header.menuItems.serialnumber"]}
                        {globalState.customer.orderInfo.posCode}
                      </span>
                    </div>
                  </div>
                </div>
              ) : null}
              <ScrollTabs
                tabs={$tabs}
                allTabs={$allTabs}
                items={$tabItems}
                searchPlaceholder={msg}
                menuType={globalState.customer.menuType}
                isFillFilter={
                  (globalState.customer.filterTag &&
                    globalState.customer.filterTag.length > 0) ||
                  (globalState.customer.filterVegan &&
                    globalState.customer.filterVegan.length > 0)
                }
                itemOnSelected={() => {
                  dispatch({
                    type: "UPDATE_STATE",
                    payload: [{ key: "searchInput", val: "" }],
                  });
                }}
                openFilter={() => {
                  dispatch({
                    type: "UPDATE_STATE",
                    payload: [{ key: "tagPopupToggle", val: true }],
                  });
                }}
                searchOnChange={(val) => {
                  dispatch({
                    type: "UPDATE_STATE",
                    payload: [{ key: "searchInput", val }],
                  });
                }}
                menuTypeSwitch={() => {
                  dispatchGlobal({
                    type: "UPDATE",
                    payload: [
                      {
                        key: "customer",
                        val: {
                          ...globalState.customer,
                          menuType: globalState.customer.menuType === 1 ? 2 : 1,
                        },
                      },
                    ],
                  });
                }}
                renderItem={(itemInfo, index) => (
                  <div
                    key={index}
                    className={cls(
                      "Pages__meals pt-2 pt-sm-4",
                      itemInfo.product_status === 3 ? " isSoldOut" : "",
                      globalState.customer.menuType === 1 ? "isRwd" : ""
                    )}
                    ref={(ref) => {
                      if (
                        ref &&
                        _menuListRef.current.filter((e) => e === ref) < 1
                      ) {
                        _menuListRef.current.push(ref);
                      }
                    }}
                    onClick={async () => {
                      // 正常銷售才可進入
                      if (itemInfo.product_status === 2) {
                        TimeOutRemove();
                        dispatchGlobal({
                          type: "UPDATE",
                          payload: [
                            {
                              key: "customer",
                              val: {
                                ...globalState.customer,
                                lastSelectedItemScrolltop:
                                  window.document.body.scrollTop,
                                currentStep: "3.1",
                                currentQrStep: "1.1",
                                mealDetail: itemInfo,
                                isFromOrderDetail: false,
                              },
                            },
                          ],
                        });
                      }
                    }}
                  >
                    <div className="Pages__meals__imgBoxBlock d-flex flex-nowrap">
                      <div className="Pages__meals__imgBox">
                        <img
                          src={itemInfo.img ? itemInfo.img : defaultImg}
                          alt=""
                        />
                        {/* 單一產品總數 */}
                        {(() => {
                          let findProduct =
                            globalState.customer.mealOrderDetail.find(
                              (f) => f.id === itemInfo.id
                            );
                          if (findProduct) {
                            let productQuantity =
                              findProduct.specification.reduce(
                                (currSpec, itemSpec) => {
                                  return (
                                    currSpec +
                                    itemSpec.combination.reduce(
                                      (currCombi, itemCombi) => {
                                        return currCombi + itemCombi.quantity;
                                      },
                                      0
                                    )
                                  );
                                },
                                0
                              );
                            return (
                              <div className="Pages__meals__notes d-flex justify-content-center align-items-center">
                                <span>{productQuantity}</span>
                              </div>
                            );
                          } else {
                            // return null
                          }
                        })()}
                      </div>
                      <div
                        className={cls(
                          "Pages__meals__info d-flex flex-column flex-sm-row",
                          globalState.customer.menuType === 1
                            ? ""
                            : "col justify-content-center justify-content-sm-start align-items-sm-center",
                          globalState.langType
                        )}
                      >
                        <div className="d-flex flex-column col-sm p-0">
                          <span className="Pages__meals__title mt-1 mb-1 mt-sm-2 mb-sm-2">
                            {itemInfo.title}
                          </span>
                          <div className="Pages__meals__icon d-flex flex-wrap mt-1 mb-1 mt-sm-2 mb-sm-2">
                            {itemInfo.recommend.map((recommendInfo, index) => (
                              <Tooltip
                                key={index}
                                placement="bottom"
                                trigger={["hover", "click"]}
                                overlay={
                                  <span children={recommendInfo.description} />
                                }
                              >
                                <img
                                  style={{ height: "25px" }}
                                  className="mr-1 mb-1"
                                  src={recommendInfo.icon}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                  }}
                                  alt=""
                                />
                              </Tooltip>
                            ))}
                          </div>
                          {globalState.customer.menuType === 1 ? (
                            <div translate="no" className="d-flex mx-auto">
                              <span className="mt-1 mb-1 mt-sm-2 mb-sm-2 d-inline-block d-sm-none">
                                $ {itemInfo.price}
                              </span>
                              {itemInfo.product_status === 3 ? (
                                <span className="mt-1 mb-1 ml-2 mr-sm-2 mt-sm-2 mb-sm-2">
                                  <FormattedMessage id="pages.takeOrder.soldOut" />
                                </span>
                              ) : null}
                              <span className="mt-1 mb-1 mt-sm-2 mb-sm-2 d-sm-inline-block d-none">
                                $ {itemInfo.price}
                              </span>
                            </div>
                          ) : null}
                        </div>
                        {globalState.customer.menuType === 1 ? null : (
                          <div
                            translate="no"
                            className="d-flex justify-content-sm-end"
                          >
                            <span className="mt-1 mb-1 mt-sm-2 mb-sm-2 d-inline-block d-sm-none">
                              $ {itemInfo.price}
                            </span>
                            {itemInfo.product_status === 3 ? (
                              <span className="mt-1 mb-1 ml-2 mr-sm-2 mt-sm-2 mb-sm-2">
                                <FormattedMessage id="pages.takeOrder.soldOut" />
                              </span>
                            ) : null}
                            <span className="mt-1 mb-1 mt-sm-2 mb-sm-2 d-sm-inline-block d-none">
                              $ {itemInfo.price}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              />
            </>
          );
        }}
      />
      {/* notes */}
      <div
        className="Pages__notes pl-4 pr-4 p-sm-0"
        style={{ cursor: "pointer" }}
        onClick={() => {
          if (
            !globalState.customer.mealOrderDetail ||
            globalState.customer.mealOrderDetail.length <= 0 ||
            state.mealList.length <= 0
          ) {
          } else {
            dispatchGlobal({
              type: "UPDATE",
              payload: [
                {
                  key: "customer",
                  val: {
                    ...globalState.customer,
                    lastSelectedItemScrolltop: null,
                    currentStep: "4",
                    currentQrStep: "2",
                  },
                },
              ],
            });
          }
        }}
      >
        <div className="p-0 pt-2 pb-2 d-flex justify-content-between align-items-center">
          <div className="d-flex flex-wrap">
            <div className="d-flex align-items-center">
              <FormattedMessage id="pages.takeOrder.step3.notesChoosed" />
              <span className="mr-2 ml-2 Pages__notes__focusText">
                {handleTotalPrice.totalMealQuantity}
              </span>
              <FormattedMessage id="pages.takeOrder.step3.notesUnit" />
            </div>
            <div>
              <FormattedMessage id="pages.takeOrder.step3.notesTotalAmount" />
              <span
                translate="no"
                className="mr-2 ml-2 Pages__notes__focusText"
              >
                $
                {handleTotalPrice.dineInSpecPrice +
                  handleTotalPrice.dineInTotalPrice +
                  handleTotalPrice.takeoutInSpecPrice +
                  handleTotalPrice.takeoutInTotalPrice}
                {(() => {
                  const {
                    dineInSpecPrice,
                    dineInTotalPrice,
                    takeoutInSpecPrice,
                    takeoutInTotalPrice,
                  } = globalState.customer.orderDetail;
                })()}
              </span>
            </div>
          </div>
          <CusButton.Red
            className="p-0 pt-2 pb-2 order-step3-saveOrder"
            disabled={
              !globalState.customer.mealOrderDetail ||
              globalState.customer.mealOrderDetail.length <= 0 ||
              state.mealList.length <= 0
            }
            children={
              <FormattedMessage id="pages.takeOrder.step3.notesButtonSaveOrder" />
            }
            onClick={async () => {
              TimeOutRemove();
              let productList = [];
              globalState.customer.mealOrderDetail.map((eachProduct) => {
                eachProduct.specification.map((eachSpec) => {
                  eachSpec.combination.map((eachCombi) => {
                    productList.push({
                      name: `${eachProduct.name}${
                        eachSpec.name ? ` ${eachSpec.name}` : ""
                      }`,
                      id: String(eachSpec.id),
                      price: formatNumber(eachSpec.price, 2),
                      category: eachProduct.categoryName,
                      variant: eachCombi.takeout ? "Takeout" : "DineIn",
                      quantity: eachCombi.quantity,
                    });
                  });
                });
              });
              console.log("selectedExtra:");
              console.debug(globalState.selectedExtra);
              if (!globalState.selectedExtra) {
                dispatchGlobal({
                  type: "UPDATE",
                  payload: [
                    {
                      key: "selectedExtra",
                      val: {
                        selectedExtraA: [],
                        selectedExtraQ: {},
                      },
                    },
                  ],
                });
              } else {
                dispatchGlobal({
                  type: "UPDATE",
                  payload: [
                    {
                      key: "selectedExtra",
                      val: {
                        ...globalState.selectedExtra,
                        selectedExtraQ: {},
                      },
                    },
                  ],
                });
              }

              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "checkout",
                ecommerce: {
                  checkout: {
                    actionField: { step: 2 },
                    products: productList,
                  },
                },
              });
            }}
          />
        </div>
      </div>
      {/* 標籤篩選視窗 */}
      {(() => {
        if (!state.tagPopupToggle) return null;
        return (
          <Tool_CusFilter
            tagGroup={state.tagList}
            selectedItems={globalState.customer.filterTag}
            selectedVeganItems={globalState.customer.filterVegan}
            onClose={() => {
              dispatch({
                type: "UPDATE_STATE",
                payload: [{ key: "tagPopupToggle", val: false }],
              });
            }}
            onSelectItem={(tagIds) => {
              dispatch({
                type: "UPDATE_STATE",
                payload: [
                  { key: "tagSelected", val: tagIds.allergen },
                  { key: "veganSelected", val: tagIds.vegan },
                ],
              });
              dispatchGlobal({
                type: "UPDATE",
                payload: [
                  {
                    key: "customer",
                    val: {
                      ...globalState.customer,
                      filterTag: tagIds.allergen,
                      filterVegan: tagIds.vegan,
                    },
                  },
                ],
              });
            }}
          />
        );
      })()}
    </>
  );
}

export default withRouter(OrderStep_3);
